import React from "react";
import PositionsPopupsHead from "./PositionsPopupsHead";
import PositionsPopupsBody from "./PositionsPopupsBody";
import { useGetSpecificDeviceQuery } from "../../../Redux/Devicestwo";

export default function PositionsPopups({ mark, lat, lon, devicestatus }) {
	let { data: DeviceData } = useGetSpecificDeviceQuery(mark?.deviceId, {
		skip: !mark?.deviceId,
	});
	const lang = localStorage.getItem("lang") || "en";
	return (
		<>
			<div
				className={`device-popup ${
					lang === "en" ? "device-popup-ltr" : "device-popup-rtl"
				}`}
			>
				<PositionsPopupsHead
					DeviceData={DeviceData}
					devicestatus={devicestatus}
					mark={mark}
				/>
				<PositionsPopupsBody mark={mark} devicestatus={devicestatus} />
			</div>
		</>
	);
}
